"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var ClassUtil_1 = require("../util/ClassUtil");
var CipherKey_1 = require("../derived/CipherKey");
var MacKey_1 = require("../derived/MacKey");
var MessageKeys = (function () {
    function MessageKeys() {
        this.cipher_key = new CipherKey_1.default();
        this.counter = -1;
        this.mac_key = new MacKey_1.default(new Uint8Array([]));
    }
    MessageKeys.new = function (cipher_key, mac_key, counter) {
        var mk = ClassUtil_1.default.new_instance(MessageKeys);
        mk.cipher_key = cipher_key;
        mk.mac_key = mac_key;
        mk.counter = counter;
        return mk;
    };
    MessageKeys.prototype._counter_as_nonce = function () {
        var nonce = new ArrayBuffer(8);
        new DataView(nonce).setUint32(0, this.counter);
        return new Uint8Array(nonce);
    };
    MessageKeys.prototype.encrypt = function (plaintext) {
        return this.cipher_key.encrypt(plaintext, this._counter_as_nonce());
    };
    MessageKeys.prototype.decrypt = function (ciphertext) {
        return this.cipher_key.decrypt(ciphertext, this._counter_as_nonce());
    };
    MessageKeys.prototype.encode = function (encoder) {
        encoder.object(3);
        encoder.u8(0);
        this.cipher_key.encode(encoder);
        encoder.u8(1);
        this.mac_key.encode(encoder);
        encoder.u8(2);
        return encoder.u32(this.counter);
    };
    MessageKeys.decode = function (decoder) {
        var self = ClassUtil_1.default.new_instance(MessageKeys);
        var nprops = decoder.object();
        for (var index = 0; index <= nprops - 1; index++) {
            switch (decoder.u8()) {
                case 0:
                    self.cipher_key = CipherKey_1.default.decode(decoder);
                    break;
                case 1:
                    self.mac_key = MacKey_1.default.decode(decoder);
                    break;
                case 2:
                    self.counter = decoder.u32();
                    break;
                default:
                    decoder.skip();
            }
        }
        return self;
    };
    return MessageKeys;
}());
exports.default = MessageKeys;



//////////////////
// WEBPACK FOOTER
// ../proteus/dist/session/MessageKeys.js
// module id = 60
// module chunks = 0 1